import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Services } from '..'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { FormsModule } from '@angular/forms'
import { NgIf } from '@angular/common'

@Component({
    templateUrl: './prompt-bool.component.html',
    styleUrls: ['./modal.css'],
    standalone: true,
    imports: [FaIconComponent, FormsModule, NgIf],
})
export class PromptBoolComponent {
    faCircleQuestion = faCircleQuestion
    constructor(
        private _activeModal: NgbActiveModal,
        private services: Services,
    ) {}
    public title!: string
    public message!: string
    public input1Label!: string
    public input2Label!: string
    public boolVal1: boolean = true
    public boolVal2: boolean = true

    public yes(): void {
        this._activeModal.close([this.boolVal1, this.boolVal2])
    }
    public no(): void {
        this._activeModal.dismiss('cancel')
    }
}
